import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

const msalObj = new PublicClientApplication(msalConfig);

export default msalObj;